export default __webpack_public_path__ + "9b31293ea96c8dfa518b45622da82a13.jpg";